import { html, render } from 'lit';
import { Entidad } from '../../../../data/Entidad';
import { _DICC_ALUMNO_MOVPAGO_FOLIO } from '../../../../data/modulo/FinanzasEstadoCuenta';
import _L from '../../../../util/Labels';
import '../../../components/Icon';
import { _ModalSimple } from "../../../controlD3/ModalThings/ModalSimple";
import { ModalThingsUtil } from '../../../controlD3/ModalThings/Utils';
import '../../../controlWC/FileIcoComponent';
import '../../../controlWC/TooltipComponent';
import { UIUtilFormat } from '../../../util/Format';
import { UIUtilTime } from '../../../util/Time';
import { UIUtilViewData } from '../../../util/ViewData';
import { AlumnoEdoCtaFacturacionUtil } from '../AlumnoEdoCtaFacturacionForm/FacturacionUtil';
import { AlumnoEdoCtaUtil } from '../AlumnoEdoCtaUtil';
import ic_download from '/image/iconos/ic_download.svg?raw';
import ic_eye from '/image/iconos/ic_eye_v2.svg?raw';
// import { HTMLFileIcoElement } from '../../../controlWC/FileIcoComponent';

import CCategoriaMovimiento = Entidad.CFinanzaCategoriaMovimiento;

type IMovimientoDetalle = AlumnoEdoCtaUtil.IMovimientoDetalle

export interface AlumnoEdoCtaMovDetallePagoModalOptions {
    Alumno: Entidad.IAlumno;
    MovDetalle: IMovimientoDetalle;
    OnClickVerOtrosCargos?: () => void;
}


export function AlumnoEdoCtaMovDetallePagoModal(options: AlumnoEdoCtaMovDetallePagoModalOptions) {
    const { Alumno: alumno, MovDetalle: movDetalle, OnClickVerOtrosCargos: onClickVerOtrosCargos } = options;
    if (![CCategoriaMovimiento.PagoCompleto, CCategoriaMovimiento.PagoParcial].includes(movDetalle.Categoria)) {
        console.warn("AlumnoEdoCtaMovDetallePagoModal: El detalle no es de tipo pago completo o parcial");
        return;
    }

    const tieneCargosRelacionados = movDetalle.PagosMovRelacionados && movDetalle.PagosMovRelacionados.length > 0;
    const folioPago = _DICC_ALUMNO_MOVPAGO_FOLIO.get(movDetalle.FolioPago);
    const esPagoOnlinePendiente = AlumnoEdoCtaUtil._IsPagoOnlinePendiente(movDetalle);
    const clickVerOtrosCargos = tieneCargosRelacionados && !!onClickVerOtrosCargos
        ? (mt: ModalThingsUtil.IModalThings) => {
            mt.Modal._Ocultar();
            onClickVerOtrosCargos()
        }
        : undefined;
    const fnValidateToday = (dt1: string) => UIUtilTime._GetValidatorDateYMDV2(new Date(dt1)) === UIUtilTime._GetValidatorDateYMDV2(new Date());
    const incluyeInfoFactura = !!folioPago?.RequiereFactura || movDetalle.IdFacturaFolio != 0; // Mostrar info factura: si el pago en línea requiere factura o si el movimiento tiene folio de factura asociado (en caso de no ser pago en línea)

    _ModalSimple({
        Title: (() => {
            let strText = UIUtilViewData._GetStr_CategoriaMovimiento(movDetalle.Categoria);
            if (folioPago) {
                if (esPagoOnlinePendiente) {
                    strText += ` (${_L("general.pendiente").toLowerCase()})`;
                }
                strText += ` - ${folioPago.Folio}`;
            }
            return strText;
        })(),
        Width: 500,
        DrawContent: (content, mt) => {
            render(html`
                <div class="alumnoedocta_modaldetallepago_container">
                    <p>
                        <b>${_L("panelfinanzasedocuenta.d_field_descripcion")}:</b>
                        <span>${movDetalle.ParentMovimiento.Cargo}</span>
                    </p>
                    <p>
                        <b>${_L("general.tipo")}:</b>
                        <span>${UIUtilViewData._GetStr_CategoriaMovimiento(movDetalle.Categoria)}</span>
                    </p>
                    <p>
                        <b>${_L("panelfinanzasedocuenta.d_field_pagoabono")}:</b>
                        <span>${UIUtilFormat._CurrencyFmt(movDetalle.Valor)}</span>
                    </p>
                    <p>
                        <b>${_L("general.fechapago")}:</b>
                        <span>${movDetalle.FechaAplicacion ? UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(movDetalle.FechaAplicacion, alumno.IdKinder, "dd/mm/yyyy h12:mm") : _L("general.pendiente")}</span>
                    </p>
                    <p>
                        <b>${_L("panelfinanzasedocuenta.d_field_metodopago")}:</b>
                        <span>${AlumnoEdoCtaUtil._GetNombreMetodoPago(movDetalle.IdMetodoPago)}</span>
                    </p>


                    ${!!folioPago
                    ? html`
                        <fieldset>
                            <legend>
                                ${_L("panelfinanzasedocuenta.modaldetallepago.info_online_payment")}
                            </legend>

                            <p>
                                <b>${_L("panelfinanzasedocuenta.modaldetallepago.folio")}:</b>
                                <span>${folioPago.Folio}</span>
                            </p>

                            <p>
                                <b>${_L("general.tipo")}:</b>
                                <span>${UIUtilViewData._GetStr_FinanzaPagoEnLineaFormaPago(folioPago.FormaPago)}</span>
                            </p>

                            <p>
                                <b>${_L("general.estado")}:</b>
                                <span style="color: ${esPagoOnlinePendiente ? "var(--color_app_orange2)" : "var(--color-info)"};">
                                    ${esPagoOnlinePendiente ? _L("general.pendiente") : _L("general.success")}
                                </span>
                            </p>

                            <p>
                                <b>${_L("general.fecharegistro")}:</b>
                                <span>${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(folioPago.FechaCreacion, alumno.IdKinder, "dd/mm/yyyy h12:mm")}</span>
                            </p>

                            ${esPagoOnlinePendiente && folioPago.FechaVigencia
                            ? html`
                            <p>
                                <b>${_L("panelfinanzasedocuenta.modaldetallepago.fecha_vencimiento")}:</b>
                                <span style="color: ${fnValidateToday(folioPago.FechaVigencia) ? "var(--color_app_red1)" : "var(--color_app_orange2)"};">
                                    ${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(folioPago.FechaVigencia, alumno.IdKinder)}
                                </span>
                            </p>`
                            : null}

                            <p>
                                <b>${_L("general.total")}:</b>
                                <span>${UIUtilFormat._CurrencyFmt(folioPago.Montos.reduce((acc, monto) => acc + monto, 0))}</span>
                            </p>

                            <p>
                                <b>
                                    ${_L("panelfinanzasedocuenta.modaldetallepago.otros_cargos_rels")}
                                    ${clickVerOtrosCargos
                            ? html`<a href="javascript:void(0);" @click=${() => clickVerOtrosCargos(mt)}>(${_L("panelfinanzasedocuenta.modaldetallepago.ver_movs")})</a>`
                            : null}
                                    :
                                </b>
                                <div>
                                    ${(() => (tieneCargosRelacionados
                            ? movDetalle.PagosMovRelacionados.map(d => html`<div>- ${d.ParentMovimiento.Cargo}: ${UIUtilFormat._CurrencyFmt(d.Valor)}</div>`)
                            : html`<i>${_L("panelfinanzasedocuenta.modaldetallepago.no_hay_otros_cargos_rels")}</i>`
                        ))()}
                                </div>
                            </p>

                        </fieldset>
                        `
                    : null}


                    ${incluyeInfoFactura
                    ? html`
                        <fieldset>
                            <legend>
                                ${_L("panelfinanzasedocuenta.modaldetallepago.info_factura")}
                            </legend>

                            <p>
                                <b>${_L("general.estado")}:</b>
                                <span style="color: ${movDetalle.IdFacturaFolio < 0 ? "var(--color_app_red1)" : movDetalle.IdFacturaFolio > 0 ? "var(--color-info)" : "var(--color_app_orange2)"};">
                        ${({
                            "-1": _L("panelfinanzasedocuenta.tag_factura_fallo"),
                            "0": _L("general.pendiente"),
                            "1": _L("panelfinanzasedocuenta.tag_facturado"),
                        }[movDetalle.IdFacturaFolio < 0 ? "-1" : movDetalle.IdFacturaFolio > 0 ? "1" : "0"])}
                                </span>
                            </p>

                            ${movDetalle.IdFacturaFolio > 0
                            ? html`
                            <p>
                                <b>${_L("panelfinanzasedocuenta_factura.descargar_doc")}:</b>
                                <div class="cfdi_file_icons_container">
                                    ${(["xml", "pdf"] as const).map(ext => html`
                                        <div>
                                            <wc-fileico
                                                ext=${ext.toUpperCase()}
                                                style="width:58px; height:70px; cursor:pointer;"
                                            ></wc-fileico>

                                            <div class="cfdi_file_actions_container">
                                                ${ext == "pdf" ? html`
                                                <button
                                                    class="btn btn_round btn_ver"
                                                    @click=${() => AlumnoEdoCtaFacturacionUtil._VerArchivoCFDI(alumno.IdKinder, movDetalle.IdFacturaFolio, ext)}>
                                                    <app-icon .svg="${ic_eye}" .size=${"15px"} .color=${"var(--color_secondary4)"}></app-icon>
                                                    <wc-tooltip position="top">${_L("c_actions.ver")}</wc-tooltip>
                                                </button>`: null}

                                                <button
                                                    class="btn btn_round btn_descargar"
                                                    @click=${() => AlumnoEdoCtaFacturacionUtil._DescargarCFDI(alumno.IdKinder, movDetalle.IdFacturaFolio, ext, mt.Progress.node())}>
                                                    <app-icon .svg="${ic_download}" .size=${"15px"} .color=${"var(--color_secondary4)"}></app-icon>
                                                    <wc-tooltip position="top">${_L("general.descargar")}</wc-tooltip>
                                                </button>
                                            </div>
                                        </div>`)}
                                </div>
                                <button
                                    class="bg_light UI_Button"
                                    @click=${() => AlumnoEdoCtaFacturacionUtil._DescargarCFDIsZip(null, alumno.IdKinder, [movDetalle.IdFacturaFolio], mt.Progress.node())}>
                                    ${_L("general.descargartodo")}
                                </button>
                            </p>
                                `
                            : null
                        }
                        </fieldset>
                        `
                    : null}

                </div>
            `, content.node());

        },
    })
}